import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'
import { AuthProvider, RedirectProvider } from '../providers'
import NavBar from './components/NavBar'
import { CssBaseline } from '@mui/material'
import { SnackbarProvider } from 'notistack'

const container = document.getElementById('root')
if (container) {
  const root = createRoot(container)
  root.render(
    <StrictMode>
      <BrowserRouter basename="/fe">
        <AuthProvider>
          <RedirectProvider>
            <SnackbarProvider
              anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
              autoHideDuration={2000}
            >
              <CssBaseline />
              <NavBar />
              <App />
            </SnackbarProvider>
          </RedirectProvider>
        </AuthProvider>
      </BrowserRouter>
    </StrictMode>,
  )
} else {
  console.error('Failed to find the root element')
}
